import { useState } from 'react';
import styles from './RichText.module.scss';
import cx from 'classnames';
import { UI_Button } from '../Action/Button/Button';
export interface UI_RichTextProps {
	content: string;
	className?: string;
	bigText?: boolean;
	readMoreText?: string;
	readMoreButtonText?: string;
	shouldTruncate?: boolean;
}

export const UI_RichText: React.FC<UI_RichTextProps> = ({ content, className, bigText, readMoreText, readMoreButtonText, shouldTruncate }) => {
	const [readMoreToggled, setReadMoreToggled] = useState(false);
	return (
		<div className={cx(className)}>
			<div
				className={cx(styles.RichText, { [styles.RichText___bigText]: bigText }, { [styles.RichText___truncateText]: shouldTruncate })}
				dangerouslySetInnerHTML={{ __html: content }}
			/>
			{readMoreText && !readMoreToggled && (
				<UI_Button inheritsColor={true} style="secondary" onClick={() => setReadMoreToggled(true)}>
					{readMoreButtonText}
				</UI_Button>
			)}
			{readMoreText && readMoreToggled && (
				<div className={cx(styles.RichText, { [styles.RichText___bigText]: bigText })} dangerouslySetInnerHTML={{ __html: readMoreText }} />
			)}
		</div>
	);
};
